export default __webpack_public_path__ + "static/media/S1xSOLUTION.1d228dfd.jpg";